import cns from 'classnames';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { RuntimeContext } from '../../../../common/RuntimeContext';
import { ROUTE_PREFIXES } from '../../Constants';
import ReviewWorkspaceCommentBubble from '../../containers/ReviewWorkspace/ReviewWorkspaceCommentBubble';
import VerbText from '../VerbText';

class VerbBreadcrumb extends Component {
    static propTypes = {
        className: PropTypes.string,
        currentLearningAssetName: PropTypes.string,
        previousRouterLocation: PropTypes.string,
        isBuilderNavigation: PropTypes.bool,
        currentCollectionName: PropTypes.string,
        currentUserCollectionName: PropTypes.string,
        isReviewWorkspace: PropTypes.bool,
        toggleCommentPane: PropTypes.func,
        assetReviewItemsForSectionItem: PropTypes.arrayOf(PropTypes.object),
        currentSectionItemId: PropTypes.string,
        currentCollectionId: PropTypes.string,
        workspace: PropTypes.object,
        progressBar: PropTypes.oneOfType([PropTypes.element, PropTypes.bool]),
    };

    static contextType = RuntimeContext;

    _renderBreadcrumb = () => {
        const {
            currentLearningAssetName,
            previousRouterLocation,
            currentCollectionName,
            isBuilderNavigation,
            currentUserCollectionName,
            currentCollectionId,
            isReviewWorkspace = false,
        } = this.props;
        let middleRoute;

        if (isBuilderNavigation) {
            middleRoute = (
                <NavLink to={'/managelearningassets'} className={'manage-assets-link separator'}>
                    Manage Activities
                </NavLink>
            );
        } else if (isReviewWorkspace) {
            middleRoute = (
                <NavLink to={'/managereviewcontent'} className={'review-workspace-link separator'}>
                    Review Activities
                </NavLink>
            );
        } else if (previousRouterLocation?.startsWith(ROUTE_PREFIXES.COLLECTION_DETAILS)) {
            middleRoute = (
                <Fragment>
                    <NavLink to={previousRouterLocation} className={'collection-details-link separator'}>
                        {currentCollectionName}
                    </NavLink>
                </Fragment>
            );
        } else if (previousRouterLocation?.startsWith(ROUTE_PREFIXES.USERCOLLECTIONS)) {
            middleRoute = (
                <NavLink to={previousRouterLocation} className={'collection-details-link separator'}>
                    {currentCollectionName}
                </NavLink>
            );
        } else if (currentCollectionId && currentUserCollectionName) {
            middleRoute = (
                <NavLink to={`/collection/${currentCollectionId}`} className={'collection-details-link separator'}>
                    {currentUserCollectionName}
                </NavLink>
            );
        }
        const homeURL = window.location.origin === this.context.pathsWeb.clientUrl ? '/home' : '/administration';

        return (
            <div className={'nav-breadcrumbs'}>
                {middleRoute}
                {currentLearningAssetName && <span className={'separator'}>/</span>}
                <span>{currentLearningAssetName}</span>
            </div>
        );
    };

    render() {
        const {
            className,
            isReviewWorkspace,
            toggleCommentPane,
            assetReviewItemsForSectionItem = [],
            currentSectionItemId,
            workspace,
            progressBar
        } = this.props;

        const progressBarIsHidden =
            workspace.currentUserLearningAsset.type === 'REFLECTION' && workspace.activeSlideNumber === 0;

        return (
            <div className={cns('verb-breadcrumb', { 'has-progress-bar': !!progressBar && !progressBarIsHidden })}>
                <div className={cns('title', 'verb-breadcrumb-contents', className)}>
                    {this._renderBreadcrumb()}
                    {progressBar ?? null}
                </div>
                {isReviewWorkspace ? (
                    <ReviewWorkspaceCommentBubble
                        toggleCommentPane={toggleCommentPane}
                        currentSectionItemId={currentSectionItemId}
                        assetReviewItemsForSectionItem={assetReviewItemsForSectionItem}
                    />
                ) : null}
            </div>
        );
    }
}

export { VerbBreadcrumb as VerbBreadcrumbComponent };

export const mapStateToProps = (state, ownProps) => {
    const { collections } = state;
    const previousLocation = get(ownProps, 'previousRouterLocation', '');
    let currentCollectionName = '';
    let currentUserCollectionName = '';
    const historyCurrentCollectionId = get(
        ownProps,
        'history.location.state.currentUserCollection.currentCollectionId',
        ''
    );
    const historyCurrentUserCollectionId = get(ownProps, 'history.location.state.currentUserCollection.id', '');

    let currentCollectionId =
        historyCurrentCollectionId ||
        get(ownProps, 'currentUser.currentUserCollection.currentCollectionPermalink', '') ||
        get(ownProps, 'currentUser.currentUserCollection.currentCollectionId', '');

    const currentUserCollectionId =
        historyCurrentUserCollectionId || get(ownProps, 'currentUser.currentUserCollection.id', '');

    const allUserCollections = state.userCollections.byId || {};
    const currentUserCollection = allUserCollections[currentUserCollectionId];

    if (currentUserCollection) {
        const currentAssetIsInCurrentCollection =
            currentUserCollection.content.findIndex(
                (asset) => asset.userLearningAssetId === ownProps.currentUserLearningAssetId
            ) > -1;

        if (currentAssetIsInCurrentCollection) {
            currentUserCollectionName = currentUserCollection.name || currentUserCollection.collectionName;
        }
    }
    
    if (!currentCollectionName) {
        const userCollectionList = Object.values(allUserCollections);
        const foundCollections = [];
        userCollectionList.forEach(userCollection => {
            userCollection.content.forEach(content => {
                if (content.userLearningAssetId === ownProps.currentUserLearningAssetId) {
                    foundCollections.push(userCollection);
                }
            })
        });
        const currentCollection = foundCollections.sort((a,b) => b.updatedOn - a.updatedOn)[0];
        if (currentCollection) {
            currentUserCollectionName = currentCollection.name || currentCollection.collectionName;
            currentCollectionId = currentCollection._id;
        }
    }

    if (!currentCollectionName) {
        const foundCollections = [];
        const currentUserLearningAsset = get(state, 'workspace.currentUserLearningAsset', {});
        const { byId } = collections;
        const collectionList = Object.values(byId);
        (collectionList || []).forEach((collection) => {
            (collection.contentIds || []).forEach((content) => {
                if (content.id === currentUserLearningAsset.learningAssetId) {
                    foundCollections.push(collection);
                }
            })
        });
        const currentCollection = foundCollections.sort((a,b) => b.updatedOn - a.updatedOn)[0];
        if (currentCollection) {
            currentUserCollectionName = currentCollection.name || currentCollection.collectionName;
            currentCollectionId = currentCollection._id;
        }
    }

    const routeIdParam = (previousLocation && previousLocation.split('/')[2]) || '';
    if (
        routeIdParam &&
        (previousLocation.startsWith(ROUTE_PREFIXES.USERCOLLECTIONS) ||
            previousLocation.startsWith(ROUTE_PREFIXES.COLLECTION_DETAILS))
    ) {
        currentCollectionName = get(state, `collections.byPerma[${routeIdParam}].name`, 'Collection Details');
    }

    return {
        currentCollectionId,
        currentUserCollectionName,
        currentCollectionName,
        workspace: state.workspace
    };
};

export default connect(mapStateToProps)(VerbBreadcrumb);
